module.exports = __webpack_public_path__ + "static/media/mending.260089b5.png";